import styled from 'styled-components'
import { media } from '../utils/media'

export const HideTablet = styled.span`
  ${media.tablet`
    display: none;
  `}
`



// WEBPACK FOOTER //
// ./src/atoms/HideTablet.tsx